(function () {
  'use strict';

  var root = document.querySelector('[data-cc-date-field]');
  if (!root) return;

  var textInput = root.querySelector('[data-cc-date-text]');
  var output = root.querySelector('[data-cc-date-output]');
  var previewWrap = root.querySelector('[data-cc-preview-wrap]');
  var preview = root.querySelector('[data-cc-date-preview]');
  var errorEl = root.querySelector('[data-cc-date-error]');
  var format = root.dataset.format || 'iso';
  var label = root.dataset.label || 'Date';
  var property = root.dataset.property || label;
  var required = root.hasAttribute('data-required');
  var minISO = root.dataset.min || '';
  var maxISO = root.dataset.max || '';
  // hasAttribute, not ||-fallback: a deliberate "" or " " separator is valid
  var previewSep = root.hasAttribute('data-preview-separator')
    ? root.dataset.previewSeparator
    : ' · ';

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

  var ROMAN = [
    [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
    [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
    [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']
  ];

  // Standard subtractive notation, valid 1-3999.
  function toRoman(n) {
    var out = '';
    for (var i = 0; i < ROMAN.length; i++) {
      while (n >= ROMAN[i][0]) {
        out += ROMAN[i][1];
        n -= ROMAN[i][0];
      }
    }
    return out;
  }

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function toISO(date) {
    return date.y + '-' + pad2(date.m) + '-' + pad2(date.d);
  }

  // Numeric-args Date constructor is local-time — only string parsing has
  // the UTC day-shift trap. Day 0 of next month = last day of this month.
  function daysInMonth(m, y) {
    return new Date(y, m, 0).getDate();
  }

  // null = not a complete valid date. Dates get engraved permanently —
  // Feb 30 / Apr 31 / Feb 29 in non-leap years must never reach the cart.
  function parseMDY(value) {
    var match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
    if (!match) return null;
    var date = { m: +match[1], d: +match[2], y: +match[3] };
    if (date.m < 1 || date.m > 12) return null;
    if (date.y < 1900 || date.y > 2099) return null;
    if (date.d < 1 || date.d > daysInMonth(date.m, date.y)) return null;
    // Range parity with the calendar picker: typed dates respect min/max
    // too (ISO strings compare lexicographically == chronologically).
    var iso = toISO(date);
    if (minISO && iso < minISO) return null;
    if (maxISO && iso > maxISO) return null;
    return date;
  }

  function cartValue(date) {
    if (format === 'roman_numerals') {
      // LOCKED order: MONTH DAY YEAR (Alex format). The separator comes from
      // cc-join.js like every other multi-value property — the Atelier source
      // hardcoded ' ' here, but its own comment files this under the same open
      // Alex delimiter question as the multi-word stone/flower values, so it
      // follows the shared knob. The PREVIEW separator below stays independent:
      // preview_separator is a deliberate per-product design setting.
      return window.ccJoin([toRoman(date.m), toRoman(date.d), toRoman(date.y)]);
    }
    return toISO(date);
  }

  function previewValue(date) {
    if (format === 'roman_numerals') {
      return toRoman(date.m) + previewSep + toRoman(date.d) + previewSep + toRoman(date.y);
    }
    return MONTHS[date.m - 1] + ' ' + date.d + ', ' + date.y;
  }

  function setError(show) {
    if (errorEl) errorEl.hidden = !show;
    textInput.classList.toggle('has-error', show);
  }

  // The visible box is pure UI -- the cart value goes to the hidden output -- but
  // it must still never be nameless. A control with no name attribute is the one
  // shape that breaks Pipeline's cached serialiser if that list is ever
  // re-queried, so it gets an inert name plus the void form owner, exactly like
  // the engraving slot boxes. See ccNeverSubmit in cc-join.js.
  window.ccNeverSubmit(textInput, 'cc-date-text');

  function update() {
    var date = parseMDY(textInput.value);
    var filled = date ? 1 : 0;

    if (date) {
      output.value = cartValue(date);
      if (preview) preview.textContent = previewValue(date);
    } else {
      output.value = '';
      if (preview) preview.textContent = '';
    }
    // Blank date posts NO key (shared helper; never touches the name attribute).
    window.ccSubmitWhenFilled(output);

    if (previewWrap) previewWrap.hidden = filled === 0;

    document.dispatchEvent(new CustomEvent('cc:date-changed', {
      detail: {
        property: property,
        label: label,
        value: output.value,
        filled: filled,
        min: 1,
        required: required
      }
    }));
  }

  // Auto-format: the slash appears with the digit that crosses the boundary
  // (12 stays 12; the 3rd digit makes 12/1) — no trailing-slash backspace
  // traps. Pasted "12152024" or "12/15/2024" both normalize.
  textInput.addEventListener('input', function () {
    var digits = this.value.replace(/\D/g, '').slice(0, 8);
    var parts = [];
    if (digits.length > 0) parts.push(digits.slice(0, 2));
    if (digits.length > 2) parts.push(digits.slice(2, 4));
    if (digits.length > 4) parts.push(digits.slice(4, 8));
    this.value = parts.join('/');
    setError(false);   // never flag mid-typing; errors surface on blur
    update();
  });

  textInput.addEventListener('blur', function () {
    setError(this.value !== '' && !parseMDY(this.value));
  });

  update();
})();
